import React, { useEffect, useRef, useState } from "react";
import { createGlobalStyle } from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

import aviatorLogo from "../../assets/img_loading.png";
import wingoLogo from "../../assets/wingo_logo.png";
import matkaLogo from "../../assets/matka_logo.png";
import defaultLogo from "../../assets/defult_logo.png";

const API = process.env.REACT_APP_API_URL;

const LoaderStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    overflow: hidden;
  }

  .game-loader {
    height: 100vh;
    width: 100%;
    background: #000;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .game-logo {
    width: 320px;
    max-width: 50%;
    margin-bottom: 10px;
    object-fit: contain;
  }

  .main_loader {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    max-width: 85%;
  }

  .loading-wrapper {
    flex: 1;
    height: 8px;
    background: rgba(255,255,255,.15);
    border-radius: 20px;
    overflow: hidden;
  }

  .loading-bar {
    height: 100%;
    width: 0%;
    background: #ff004d;
    transition: width .03s linear;
    border-radius: 20px;
  }

  .loading-row {
    color: #ff004d;
    font-size: 20px;
    white-space: nowrap;
  }

  .fair-title {
    margin-top: 15px;
    color: #fff;
    font-size: 20px;
    text-align: center;
  }

  .red {
    color: #ff004d;
    font-weight: bold;
    font-style: italic;
  }

  .fair-text {
    margin-top: 10px;
    color: #ddd;
    max-width: 650px;
    text-align: center;
    line-height: 1.8;
    font-size: 12px;
    padding: 0 20px;
  }
`;

export default function GameLoader() {
  const location = useLocation();
  const navigate = useNavigate();
  const calledRef = useRef(false);

  const [progress, setProgress] = useState(0);

  const query = new URLSearchParams(location.search);

  const uid = query.get("uid");
  const clientId = query.get("clientId");
  const game = query.get("game") || "wingo";

  /*
  =====================================
  GAME CONFIGURATION
  =====================================
  */

  const gameConfig = {
    aviator: {
      name: "Aviator",
      logo: aviatorLogo,
      route: "/aviator",
    },

    wingo: {
      name: "Win Go",
      logo: wingoLogo,
      route: "/colorGame",
    },

    matka: {
      name: "Matka",
      logo: matkaLogo,
      route: "/matkaList",
    },

    ludo: {
      name: "Ludo",
      logo: defaultLogo,
      route: "/ludo",
    },
  };

  /*
  =====================================
  DEFAULT CONFIGURATION

  ANY UNKNOWN GAME WILL USE:
  DEFAULT LOGO
  =====================================
  */

  const currentGame =
    gameConfig[game] || {
      name: game,
      logo: defaultLogo,
      route: `/${game}`,
    };

  /*
  =====================================
  AUTO LOGIN
  =====================================
  */

  useEffect(() => {
    if (calledRef.current) return;

    calledRef.current = true;

    const autoLogin = async () => {
      try {
        if (!uid) return;

        const balanceRes = await fetch(
          `${API}/api/get-balance?uid=${uid}&clientId=${clientId}`
        );

        const balanceData = await balanceRes.json();

        if (!balanceData.status) {
          toast.error("Balance not provided by client");
          return;
        }

        const res = await fetch(`${API}/api/webapi/loginRegister`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uid,
            pwd: "123456",
            money: balanceData.balance,
            clientId,
          }),
        });

        const data = await res.json();

        if (!data.status) {
          toast.error("Login failed");
          return;
        }

        localStorage.setItem("token", data.token);

        // Navigate after loader finishes
        setTimeout(() => {
          navigate(currentGame.route);
        }, 3500);

      } catch (err) {
        console.log(err);
      }
    };

    autoLogin();

  }, [
    uid,
    clientId,
    navigate,
    currentGame.route,
  ]);

  /*
  =====================================
  LOADING PROGRESS
  =====================================
  */

  useEffect(() => {
    let value = 0;

    const interval = setInterval(() => {
      value++;

      setProgress(value);

      if (value >= 100) {
        clearInterval(interval);
      }

    }, 35);

    return () => clearInterval(interval);

  }, []);

  return (
    <>
      <LoaderStyle />

      <div className="game-loader">

        <img
          src={currentGame.logo}
          alt={currentGame.name}
          className="game-logo"
        />

        <div className="main_loader">

          <div className="loading-wrapper">
            <div
              className="loading-bar"
              style={{
                width: `${progress}%`,
              }}
            />
          </div>

          <div className="loading-row">
            <span>{progress}%</span>
          </div>

        </div>

        <div className="fair-title">
          <span className="red">
            {currentGame.name}
          </span>{" "}
          is a 100% provably fair game.
        </div>

        <div className="fair-text">
          If you find that the game has modified the game results and
          submit relevant evidence to customer service, you can receive
          a maximum compensation according to the game policy.
        </div>

      </div>

      {/*
      =====================================
      MAINTENANCE MESSAGE - DISABLED FOR NOW
      =====================================

      <div className="default-loader">
        🎮 Game is currently under maintenance.
        Please wait while we complete the update.
        It will be available again shortly.
      </div>
      */}
    </>
  );
}